import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getToken, initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAnalytics, isSupported as isAnalyticsSupported } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage'; 

const firebaseConfig = {
  apiKey: "AIzaSyBnzddeoAL-61wrQQXENS51rW7lC0TRMbc",
  authDomain: "deliveryapp-c1bf2.firebaseapp.com",
  projectId: "deliveryapp-c1bf2",
  storageBucket: 'deliveryapp-c1bf2.firebasestorage.app',
  messagingSenderId: "350874739667",
  appId: "1:350874739667:web:dfc617f40b82a046784526",
  measurementId: "G-6C50K73VRE"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const rtdb = getDatabase(app);
const functions = getFunctions(app, "us-central1");
const storage = getStorage(app); // ✅ Now this line works
const analyticsMeasurementId = firebaseConfig.measurementId || "";
const appCheckSiteKey = (process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY || "").trim();

let appCheck = null;
let analytics = null;
let analyticsEnabled = false;

export const analyticsReady =
  typeof window === "undefined"
    ? Promise.resolve(null)
    : isAnalyticsSupported()
        .then((supported) => {
          if (!supported || !analyticsMeasurementId) return null;
          analytics = getAnalytics(app);
          analyticsEnabled = true;
          return analytics;
        })
        .catch((error) => {
          console.warn("[firebase] Analytics is not available in this browser:", error);
          return null;
        });

if (typeof window !== "undefined" && appCheckSiteKey) {
  const debugToken = (process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN || "").trim();
  if (debugToken && window.location.hostname === "localhost") {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
  }

  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else if (typeof window !== "undefined" && process.env.NODE_ENV === "production") {
  console.warn(
    "[firebase] App Check site key is not configured. Set REACT_APP_FIREBASE_APPCHECK_SITE_KEY before enabling strict enforcement."
  );
}

export const getAppCheckTokenValue = async (forceRefresh = false) => {
  if (!appCheck) return "";
  try {
    const result = await getToken(appCheck, forceRefresh);
    return result?.token || "";
  } catch (error) {
    console.warn("[firebase] Failed to get App Check token:", error);
    return "";
  }
};

export const isAnalyticsEnabled = () => analyticsEnabled;
export { auth, db, rtdb, functions, storage, appCheck, analytics, analyticsMeasurementId };
